import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileEdit"><Path d="M4.5 8.5V2.5H13L19.5 9V21.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.99414 21.2502L3.49414 19.7502L3.49414 13.0068C3.49414 12.1784 4.16571 11.5068 4.99414 11.5068C5.82257 11.5068 6.49414 12.1784 6.49414 13.0068L6.49414 19.7502L4.99414 21.2502Z" stroke="currentColor" strokeLinecap="square"/><Path d="M13 2.5V9H19.5" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFileEdit;
